import {
    Badge, ListGroupItemText, ListGroupItem, ListGroupItemHeading,
} from 'reactstrap';
import { Dot } from '@s20/components/common/Dot';
import { FlexStartRow } from '../../../common/forms/FormElements';

export const Job = ({
    jobType,
    description,
    statusText,
    statusColor,
    jobStartTime,
    onSelect,
}) => (
    <ListGroupItem
        className="job cursor-pointer"
        onClick={onSelect}
        action
    >
        <ListGroupItemHeading className="mb-2">
            <FlexStartRow className="mb-2">
                <Dot
                    color="danger"
                    className="mr-1"
                />

                <small className="text-uppercase">
                    {jobType}
                </small>
            </FlexStartRow>

            {description}
        </ListGroupItemHeading>

        <ListGroupItemText className="mb-0">
            {Boolean(jobStartTime) && (
                <div className="mb-1 text-muted">
                    Starts @ {jobStartTime}
                </div>
            )}

            <FlexStartRow component="footer">
                <Badge
                    color={statusColor}
                    className="text-uppercase"
                >
                    {statusText}
                </Badge>
            </FlexStartRow>
        </ListGroupItemText>
    </ListGroupItem>
);